import React from 'react'
import { NavLink } from 'react-router-dom'
import { Link as ReactScrollLink } from 'react-scroll'

import './index.scss'

import Button from '../Button'
import Container from '../Container'

import logo from '../../assets/logos/com-acordo2.svg'

const Header = ({ options, invite }) => (
  <Container>
    <div className="home-header">
      <div>
        <NavLink to='/'><img src={logo} alt="Logo" /></NavLink>
        <ul>
          {options.map(({ text, href, to, reactScroll }) => {
            if (reactScroll) return <li key={text}><ReactScrollLink to={to} spy={true} smooth={true} duration={500}>{text}</ReactScrollLink></li>
            if (href) return <li key={text}><a href={href}>{text}</a></li>
            return <li key={text}><NavLink to={to}>{text}</NavLink></li>
          })}
        </ul>
      </div>
      <div className="home-header__buttons">
        {invite && <Button link href="#How" margin="0 10px" color="green">Recebi um convite</Button>}
        <Button link href="/login">Entrar</Button>
      </div>
    </div>
  </Container>
)

export default Header
